import MetaTag from '@/components/ui/MetaTag';
import { PageLayout } from '@/layouts/shared';
import { GetStaticPropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React from 'react';

const DepositPolicyPage = () => {
  return (
    <>
      <MetaTag title="Chính sách QUYỀN LỢI KHÁCH HÀNG 72H" description="Chính sách QUYỀN LỢI KHÁCH HÀNG 72H" />
      <div className="container tw-mx-auto md:tw-border-t tw-border-primary-main tw-pt-8 tw-pb-10">
        <div className="tw-flex tw-flex-col tw-px-0 lg:tw-px-10 tw-text-base tw-leading-6">
          <h1 className="tw-text-center tw-font-bold tw-text-lg lg:tw-text-2xl tw-mb-5 tw-uppercase">
            Chính sách QUYỀN LỢI KHÁCH HÀNG 72H
          </h1>
          <ul className="tw-mt-5 tw-flex tw-flex-col tw-gap-y-3 ">
            <li>- Áp dụng kể từ khi thanh toán đủ và nhận sản phẩm.</li>
            <li>- Thực hiện thu đổi 72H theo khung giờ làm việc của hệ thống kim cương An Thư.</li>
          </ul>
          <div className="tw-flex tw-items-center tw-justify-center tw-mt-10">
            <div>
              <div className="tw-flex">
                <span className="tw-border-t tw-border-r tw-border-l tw-block tw-w-[200px] md:tw-w-[348px] tw-p-[10px] tw-bg-secondary-70/[0.06] tw-text-primary-main tw-font-semibold ">
                  Đổi sản phẩm mới có giá trị cao hơn hoặc ngang bằng sản phẩm cũ
                </span>
                <span className="tw-w-[200px] md:tw-w-[348px] tw-border-t tw-border-r tw-p-[10px] tw-flex tw-items-center tw-justify-center tw-text-center">
                  -5%
                </span>
              </div>
              <div className="tw-flex">
                <span className="tw-border tw-block tw-w-[200px] md:tw-w-[348px] tw-p-[10px] tw-bg-secondary-70/[0.06] tw-text-primary-main tw-font-semibold ">
                  Đổi sản phẩm mới có giá trị thấp hơn hoặc An Thư thu lại sản phẩm
                </span>
                <span className="tw-w-[200px] md:tw-w-[348px] tw-border-t tw-border-b tw-border-r tw-p-[10px] tw-flex tw-items-center tw-justify-center tw-text-center">
                  -10%
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const getStaticProps = async ({ locale }: GetStaticPropsContext) => {
  return {
    props: {
      layout: PageLayout.New,
      ...(await serverSideTranslations(locale as string, ['layout'])),
    },
  };
};
export default DepositPolicyPage;
